import { graphql } from '../../../gql';

export const MY_MENTORSHIPS_QUERY = graphql(`
  query myMentorships {
    myMentorships { vouchId recipientUsername status outcome createdAt resolvedAt revokedAt }
  }
`);
